import { mainApi } from './mainApi';

type AIAssistProps = {
  organizationId: string;
  task_type: string;
  prompt: string;
  assist_data?: Record<string, any>;
};

type AIAssistResponse = {
  tokens: number;
  data: Record<string, string>;
};

// Define the API endpoint
const aiAssistApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    aiAssist: builder.mutation<AIAssistResponse, AIAssistProps>({
      query: ({ organizationId, task_type, assist_data, prompt }) => ({
        url: `/api/${organizationId}/ai-assist`,
        method: 'POST',
        body: {
          task_type,
          assist_data,
          prompt,
        },
        responseHandler: async (response) => response.json(),
      }),
    }),
  }),
});

export const { useAiAssistMutation } = aiAssistApi;
